import { all, takeEvery, put, call } from 'redux-saga/effects'
import { notification } from 'antd'
import actions from './actions'
import { SAVE_200_MSG, SAVE_200_DESC, DEL_200_MSG, DEL_200_DESC } from '../../constants'
import { list, find, save, remove } from '../../services/contactPerson'

function* fetchContactPersonsRefresh() {
  let fe = JSON.parse(localStorage.getItem('fetchContactPersons'))
  if (fe == null) {
    fe = {}
    fe.size = localStorage.getItem('pageSize') || 15
    fe.index = 0
    fe.searchTerm = '%20'
    fe.orderBy = '%20'
  } else {
    fe.searchTerm = '%20'
    fe.orderBy = '%20'
  }
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, fe.size, fe.index, fe.searchTerm, fe.orderBy)
  yield put({
    type: actions.LIST_CONTACTPERSON,
    result,
  })
}

function* fetchContactPersons({ size, index, searchTerm, orderBy }) {
  // Load last params froom last session.
  if (!size && !index && !searchTerm && !orderBy) {
    const fe = JSON.parse(localStorage.getItem('fetchContactPersons'))
    if (fe != null) {
      size = fe.size || 15
      index = fe.index || 0
      searchTerm = fe.searchTerm || '%20'
      orderBy = fe.orderBy || '%20'
    } else {
      size = size || localStorage.getItem('pageSize') || 15
      index = 0
      searchTerm = '%20'
      orderBy = '%20'
    }
  }
  localStorage.setItem('fetchContactPersons', JSON.stringify({ size, index, searchTerm, orderBy }))
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, size, index, searchTerm, orderBy)
  yield put({
    type: actions.LIST_CONTACTPERSON,
    result,
  })
}

function* fetchContactPersonEdit({ id }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(find, id)
  yield put({
    type: actions.EDIT_CONTACTPERSON,
    result,
  })
}

function* fetchContactPersonSave(values) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(save, values)
  if (result !== null) {
    notification.success({ message: SAVE_200_MSG, description: SAVE_200_DESC })
  }
  yield put({
    type: actions.SAVE_CONTACTPERSON_RECIEVED,
    result,
  })
  yield put({
    type: actions.RE_FETCH_CONTACTPERSONS,
  })
  yield put({
    type: 'dropdown/FETCH',
    entity: 'dropdown/CONTACT_PERSON',
  })
}

function* fetchContactPersonDelete(values) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(remove, values)
  if (result !== null) {
    notification.success({ message: DEL_200_MSG, description: DEL_200_DESC })
  }
  yield put({
    type: actions.DELETE_CONTACTPERSON_RECIEVED,
    result,
  })
  yield put({
    type: actions.RE_FETCH_CONTACTPERSONS,
  })
  yield put({
    type: 'dropdown/FETCH',
    entity: 'dropdown/CONTACT_PERSON',
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.FETCH_CONTACTPERSONS, fetchContactPersons),
    takeEvery(actions.FETCH_CONTACTPERSON, fetchContactPersonEdit),
    takeEvery(actions.SAVE_CONTACTPERSON, fetchContactPersonSave),
    takeEvery(actions.DELETE_CONTACTPERSON, fetchContactPersonDelete),
    takeEvery(actions.RE_FETCH_CONTACTPERSONS, fetchContactPersonsRefresh),
  ])
}
